import BuyerApi from "./buyer-api";
import BarkCarousel from "./bark-carousel";
import { startNewBark } from "./start-new-bark";

export default function(opts){

    const options = $.extend(true,{
        cards: {
            desktopClasses: 'col-4 col-lg-3',
            mobileClasses: 'col-8',
            labelClasses: 'mb-0 p-3 text-grey-600'
        },
        barkMode: $('#buyer-next-bark').data('bark-mode') ?? null
    }, opts);

    const {Handlebars} = window;
    const buyerApi = BuyerApi();

    const init = () => {
        bindListeners();
    };

    /**
     * Bind events
     * @param {jQuery|string} scope A jQuery-able item. Elements outside this scope will not get events bound to them
     */
    const bindListeners = (scope = '#buyer-next-bark') => {
        $('body').on('click', '#buyer-next-bark button.js--new-bark', function (e) {
            e.preventDefault();
            $('.js-initiate-new-bark').not(this).first().trigger('click');
        });

        $('body').off('click.bnbCateg').on('click.bnbCateg', '#buyer-next-bark .category-link', function (e) {
            e.preventDefault();

            $('.modal').modal('hide');
            startNewBark({
                categoryId: $(e.currentTarget).data('category-id'),
                barkMode: $(e.currentTarget).data('bark-mode') ?? 'bnb-card',
            });
        });

        $('.category-link', scope).off('click.catLink').on('click.catLink', (e) => {
            e.preventDefault();

            $('.modal').modal('hide');
            startNewBark({
                categoryId: $(e.currentTarget).data('category-id'),
                barkMode: $(e.currentTarget).data('bark-mode') ?? 'bnb-card',
            });
        });

    }

    /**
     * Render the BNB cards
     * @param {array} categories
     * @returns {array} An array in the form [{desktopCard: str:html, mobileCard: str:html}, ...]
     */
    const buildNextBarkCards = (categories) => {
        try {
            const carouselItemTemplate       = Handlebars.compile($('#buyer-next-bark-item').html());
            const mobileCarouselItemTemplate = Handlebars.compile($('#buyer-next-bark-item-mobile').html());
            const dataBarkMode  = options.barkMode ?? 'bnb-card';
            return categories.map((category) => {
                let desktopCard = carouselItemTemplate({
                    category: category,
                    desktop_classes: options.cards.desktopClasses,
                    label_classes: options.cards.labelClasses,
                    dataBarkMode
                })

                let mobileCard = mobileCarouselItemTemplate({
                    category: category,
                    mobile_classes: options.cards.mobileClasses,
                    label_classes: options.cards.labelClasses,
                    dataBarkMode
                })

                return {desktopCard, mobileCard}
            })
        } catch (exc) {
            bugsnagClient.notify(new Error('Failed to compile the buyer next bark cards'), { metaData: exc });
            return [{desktopCard: '', mobileCard: ''}];
        }
    }

    const appendCards = (cards, desktopSelector, mobileSelector) => {
        cards.map((card) => {
            if (card.desktopCard && desktopSelector) {
                desktopSelector.append(card.desktopCard);
            }

            if (card.mobileCard && mobileSelector) {
                mobileSelector.append(card.mobileCard)
            }
        })
    }

    /**
     * Get buyer next barks data and then render
     * @param {jQuery|string} outputSelector A jQuery-able item of where to render
     * @param {number} minItems The minimum number of items before the section can show
     * @param {number|null} maxItems Null to render all items
     * @returns {Promise}
     */
    const getNextBarksAndRender = (outputSelector, minItems = 4, maxItems = null) => {
        return new Promise((resolve, reject) => {
            buyerApi.getNextBarkSuggestions(data => {
                const output = $(outputSelector);
                let { data: categories } = data;

                if (!categories || categories.length < minItems) {
                    reject();
                    return;
                }

                if (maxItems && categories.length > maxItems) {
                    categories = categories.slice(0, maxItems);
                }

                output.empty();

                buildNextBarkCards(categories).forEach(({desktopCard}) => {
                    output.append(desktopCard);
                });

                bindListeners(output);

                resolve(categories);
            }, reject);
        });
    };

    /*
     * Please pass in a jQuery selector and it will then just append the cards to that selector,
     * mobile selector is optional
     * @param $appendToDesktop
     * @param $appendToMobile
     */
    const getNextBarksAndAppend = ($appendToDesktop, $appendToMobile) => {
        buyerApi.getNextBarkSuggestions(
            (data) => {
                const { data: categories } = data;

                if (categories?.length < 4) {
                    hideNextBarkSection();
                    return;
                }

                let cards = buildNextBarkCards(categories);

                appendCards(cards, $appendToDesktop, $appendToMobile);

                // Maybe this should be pulled out
                let carousel = BarkCarousel();
                carousel.init($appendToDesktop);

                showNextBarkSection();

                bindListeners();
            },
            (error) => {
                hideNextBarkSection();
                bugsnagClient.notify(new Error('Couldn\'t get buyer next barks'), { metaData: error });
            }
        );
    }

    const showNextBarkSection = () => {
        if (window.BuyerApp) {
            window.BuyerApp.launchModule('bnb','__bnb',{showPlaceBarkButton:true});
        }
        $('#buyer-next-bark').removeClass('d-none');
    }

    const hideNextBarkSection = () => {
        $('#buyer-next-bark').addClass('d-none');
    }

    init();

    return {
        getNextBarksAndAppend,
        getNextBarksAndRender
    }
}
